import React, { useEffect, useState } from "react";
import FormulaHeader from "./FormulaHeader";

const FormulaLiveScore = () => {
  const [live, setLive] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchdata = () => {
      fetch(
        `${process.env.REACT_APP_API_FORMULA}/drivers/season/5?api_token=${process.env.REACT_APP_API_TOKEN}&include=driver`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          setLive(data.data);
        });
    };
    fetchdata();
  }, []);

  useEffect(() => {
    const fetchdata = () => {
      fetch(
        `${process.env.REACT_APP_API_FORMULA}/livescores/now?api_token=${process.env.REACT_APP_API_TOKEN}&include=track`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          setData(data.data);
        });
    };
    fetchdata();
  }, []);

  return (
    <div>
      <div>
        <div className="container">
          <div className="card mt-2">
            <div className="card-body">
              <h2 className="text-center font-weight-bold text-muted">
                <img src="https://img.icons8.com/color/48/000000/racing-lap.png" />
                Formula Racing
              </h2>
              <FormulaHeader />
            </div>
          </div>
          {/* Live cricket score */}
          <div className="card mt-2 ">
            <div className="card-body">
              {data.map((livedata) => {
                return <h2>{livedata.results.data[0].driver_id}</h2>;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormulaLiveScore;
